<template>
  <v-app id="cidadaos-duplicados" class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome da equipe"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :search="search"
          item-key="index"
          ref="tableCalculadoraDePessoas"
          class="elevation-1"
        >
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao">
              {{ calculatePageSum() }} de {{ calculateTotalSum() }} pessoas
            </span>
          </template>

          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  name: 'TabelaCadastrosVuetfy',
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    data_secretaria_de_saude: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    texto_esus_pec: {
      type: String,
      default: '',
    },
    data_esus_pec: {
      type: String,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      enabled: null,
      search: '',
      headers: [
        {
          text: 'ESTABELECIMENTO',
          align: 'start',
          filterable: true,
          sortable: false,
          value: 'estabelecimento',
        },
        {
          text: 'EQUIPE',
          align: 'start',
          filterable: true,
          sortable: false,
          value: 'no_equipe',
        },
        {
          text: 'INE',
          align: 'start',
          filterable: true,
          sortable: false,
          value: 'ine',
        },
        {
          text: 'IDADE',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'idade',
        },
        {
          text: 'PESSOAS',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'pessoas_idade',
        },
      ],
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => {
        let dados = JSON.parse(item.dados)
        let estabelecimento = ''
        let no_equipe = ''
        if (dados != null) {
          estabelecimento = dados.no_unidade_saude ?? ''
          no_equipe = dados.no_equipe ?? ''
        }

        return {
          index: index,
          estabelecimento,
          no_equipe,
          ...item,
        }
      })
    },
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },
    getPagination(options) {
      this.currentPage = options.page
    },
    calculatePageSum() {
      const startIndex = (this.currentPage - 1) * 10
      const endIndex = startIndex + 10
      let pageItems = []
      if (this.search != '') {
        pageItems =
          this.$refs.tableCalculadoraDePessoas?.$children[0]?.filteredItems.slice(
            startIndex,
            endIndex
          )
      } else {
        pageItems = this.indexedItems.slice(startIndex, endIndex)
      }
      return pageItems.reduce(
        (sum, item) => sum + parseInt(item.pessoas_idade),
        0
      )
    },
    calculateTotalSum() {
      if (this.search != '') {
        return this.$refs.tableCalculadoraDePessoas?.$children[0]?.filteredItems.reduce(
          (sum, item) => sum + parseInt(item.pessoas_idade),
          0
        )
      } else {
        return this.indexedItems.reduce(
          (sum, item) => sum + parseInt(item.pessoas_idade),
          0
        )
      }
    },
  },
}
</script>

<style lang="scss"></style>
